// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".df-text-field[data-v-ea6612b2]{flex:1}.df-text-field[data-v-ea6612b2]  .v-text-field__slot{flex-direction:column}.error--text[data-v-ea6612b2]  .df-text-field label{caret-color:#b2140a!important;color:#b2140a!important}", ""]);
// Exports
module.exports = exports;
